import { callAPI } from '../../../services/api.service';
import { IPageDataModel } from '../../../interfaces/book.interface';

interface BookData {
  pages: { [key: string]: IPageDataModel };
}

export const fetchBookData = async (bookIdAdmin: string | null, bookId: string | null) => {
  try {
    const bookID = bookIdAdmin || bookId || '';
    if (bookID) {
      const data: BookData = (await callAPI(`api/books/${bookID}`))?.data;
      return { data, totalPages: Object.keys(data.pages).length * 2 + 1 };
    } else {
      throw new Error('bookId missing');
    }
  } catch (error) {
    throw error; // You can handle or log the error here if necessary
  }
};
